'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M9.574 16.772a.23.23 0 0 1 .231.231v2.078a.23.23 0 0 1-.231.231H7.496a.23.23 0 0 1-.231-.23v-2.079a.23.23 0 0 1 .231-.23h2.078Zm-.231.462H7.727v1.616h1.616v-1.616Zm.288-4.006c.128 0 .231.104.231.231v2.078a.23.23 0 0 1-.231.231H7.553a.23.23 0 0 1-.231-.23v-2.079c0-.127.103-.23.231-.23h2.078Zm-3.573 0a.23.23 0 0 1 .23.231v2.078a.23.23 0 0 1-.23.231H3.98a.23.23 0 0 1-.231-.23v-2.079c0-.127.103-.23.231-.23h2.078Zm3.342.462H7.784v1.616H9.4V13.69Zm-3.574 0H4.21v1.616h1.616V13.69Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M6.572 7.929a.347.347 0 0 1 .466 0l4.719 4.293a.346.346 0 0 1 .114.257v8.375a.347.347 0 0 1-.348.347H2.087a.346.346 0 0 1-.345-.347v-8.375c0-.098.04-.191.112-.257Zm.234.725-4.372 3.978v7.876h1.314v-3.504a.23.23 0 0 1 .231-.231h2.079a.23.23 0 0 1 .23.23v3.505h4.89v-7.876L6.804 8.654Zm-.98 8.58H4.212v3.274h1.615v-3.273Zm.75-11.148a.346.346 0 0 1 .458 0l1.969 1.732v-.325h.693v.934l.995.877V6.817H8.694v-.692h3.005v.692h-.315v3.096l.719.633-.458.52-4.84-4.259-5.847 5.145-.458-.52Z",
    fill: "#3F3E4B"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "m17.773 7.885.06.044 4.718 4.293c.055.05.092.114.107.185l.007.072v8.375a.347.347 0 0 1-.277.34l-.07.007h-9.437a.346.346 0 0 1-.339-.277l-.007-.07v-8.375c0-.074.023-.144.065-.203l.048-.054 4.72-4.293a.347.347 0 0 1 .405-.044Zm-.173.769-4.372 3.978v7.876h1.315v-3.504a.23.23 0 0 1 .17-.223l.061-.008h2.078a.23.23 0 0 1 .223.17l.008.06v3.505h4.89v-7.876L17.6 8.654Zm-.979 8.58h-1.616v3.274h1.616v-3.273Zm3.748-.462c.127 0 .231.103.231.231v2.078a.231.231 0 0 1-.231.231h-2.078a.23.23 0 0 1-.231-.23v-2.079a.23.23 0 0 1 .231-.23h2.078Zm-.231.462h-1.616v1.616h1.616v-1.616Zm.288-4.006c.127 0 .231.104.231.231v2.078a.231.231 0 0 1-.231.231h-2.078a.23.23 0 0 1-.231-.23v-2.079c0-.127.103-.23.231-.23h2.078Zm-3.574 0c.128 0 .231.104.231.231v2.078a.23.23 0 0 1-.231.231h-2.078a.231.231 0 0 1-.231-.23v-2.079c0-.127.104-.23.231-.23h2.078Zm3.343.462h-1.616v1.616h1.616V13.69Zm-3.574 0h-1.616v1.616h1.616V13.69Zm1.148-7.646.06.042 1.968 1.732v-.325h.694v.934l.994.877V6.817h-1.997v-.692h3.006v.692h-.316v3.096l1.41 1.241-.457.52-5.532-4.867-4.84 4.26-.457-.52 5.07-4.46a.346.346 0 0 1 .397-.043Z",
    fill: "#87868F"
  })));
});
var FwSet0SemiDetached = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.FwSet0SemiDetached = FwSet0SemiDetached;